import React from 'react';
import ReactDOM from 'react-dom/client';
import { configureStore } from '@reduxjs/toolkit';
import { Provider } from 'react-redux';
import { setupListeners } from '@reduxjs/toolkit/query';
import { installResizeObserverLoopErrorIgnore } from './utils/ignoreResizeObserverLoopError';
import './index.css';
import App from './App';
import globalReducer from "state"; // Ensure this path is correct
import authReducer from "reducers/authReducer"; // Ensure this path is correct
import { api } from "state/api"; // Ensure this path is correct

installResizeObserverLoopErrorIgnore();

const store = configureStore({
  reducer: {
    global: globalReducer,
    auth: authReducer, // Add authReducer here
    [api.reducerPath]: api.reducer,
  },
  middleware: (getDefaultMiddleware) => 
    getDefaultMiddleware().concat(api.middleware),
});

setupListeners(store.dispatch);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
  </React.StrictMode>
);
